import * as Sentry from '@sentry/angular';
import { startClientTelemetry } from '@leadcenter/observability-client';
import config from '../.sentry/public.json';
import { environment } from './environments/environment';

export const clientTelemetry = startClientTelemetry(Sentry, config, {
  component: 'browser', development: !environment.production,
});
